require('slick-carousel');

function slickInit(item, nav, size) {

    let sliderNavigate = $(nav);
    let maxWidth = size;
    let slickVar = {
            // lazyLoad: 'ondemand',
            dots: false,
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 2,
            mobileFirst: true,
            // variableWidth: true,
            arrows: false,
            speed: 400,
            autoplay: true,
            autoplaySpeed: 7000,
            appendArrows: sliderNavigate,
            prevArrow: '<div class="people-content__nav people-content__prev"><svg width="25" height="48" viewBox="0 0 25 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path d="M23.7192 3.80295e-07C23.5508 -0.000130489 23.3839 0.0335168 23.2284 0.0988715C23.0728 0.164226 22.9317 0.260049 22.8129 0.380851L0.375778 23.0837C0.256691 23.204 0.1623 23.347 0.0977783 23.5042C0.0332565 23.6616 0 23.8302 0 24.0004C0 24.1707 0.0332565 24.3393 0.0977783 24.4967C0.1623 24.654 0.256691 24.7967 0.375778 24.9172L22.8129 47.62C22.9318 47.7405 23.0731 47.836 23.2286 47.9013C23.3841 47.9666 23.5508 48 23.7192 48C23.8875 48 24.054 47.9666 24.2095 47.9013C24.3649 47.836 24.5062 47.7405 24.6252 47.62C24.8652 47.3766 25 47.047 25 46.7033C25 46.3595 24.8652 46.0297 24.6252 45.7865L3.09404 24.0025L24.6252 2.21832C24.8652 1.97506 25 1.64544 25 1.30168C25 0.957923 24.8652 0.628182 24.6252 0.384909C24.5067 0.263468 24.3657 0.166885 24.2102 0.100839C24.0547 0.0347928 23.8878 0.00050769 23.7192 3.80295e-07Z" fill="white"/>\n' +
                '</svg>\n</div>',
            nextArrow: '<div class="people-content__nav people-content__next"><svg width="25" height="48" viewBox="0 0 25 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path d="M23.7192 3.80295e-07C23.5508 -0.000130489 23.3839 0.0335168 23.2284 0.0988715C23.0728 0.164226 22.9317 0.260049 22.8129 0.380851L0.375778 23.0837C0.256691 23.204 0.1623 23.347 0.0977783 23.5042C0.0332565 23.6616 0 23.8302 0 24.0004C0 24.1707 0.0332565 24.3393 0.0977783 24.4967C0.1623 24.654 0.256691 24.7967 0.375778 24.9172L22.8129 47.62C22.9318 47.7405 23.0731 47.836 23.2286 47.9013C23.3841 47.9666 23.5508 48 23.7192 48C23.8875 48 24.054 47.9666 24.2095 47.9013C24.3649 47.836 24.5062 47.7405 24.6252 47.62C24.8652 47.3766 25 47.047 25 46.7033C25 46.3595 24.8652 46.0297 24.6252 45.7865L3.09404 24.0025L24.6252 2.21832C24.8652 1.97506 25 1.64544 25 1.30168C25 0.957923 24.8652 0.628182 24.6252 0.384909C24.5067 0.263468 24.3657 0.166885 24.2102 0.100839C24.0547 0.0347928 23.8878 0.00050769 23.7192 3.80295e-07Z" fill="white"/>\n' +
                '</svg>\n</div>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 6,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 300,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
            ]
        },
        runSlick = function() {
            $(item).not('.slick-initialized').slick(slickVar);
        };

    runSlick();

}
slickInit('.brand__slider', '', 1025);